<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="140px">
      <el-form-item label="消息标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入消息标题"></el-input>
      </el-form-item>
      <el-form-item label="消息内容" prop="content">
        <el-input type="textarea" :rows="2" v-model="form.content" placeholder="请输入消息内容"></el-input>
      </el-form-item>
      <el-form-item label="是否有奖品" prop="hasGift">
        <el-radio-group v-model="form.hasGift">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="限制参与证书" v-if="form.hasGift == 1">
        <el-select class="filter-item" multiple v-model="form.certIds" placeholder="请选择限制参与证书">
          <el-option v-for="item in certIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="奖品失效时间" prop="giftFailureTime" v-if="form.hasGift == 1">
        <el-date-picker v-model="form.giftFailureTime" type="datetime" placeholder="选择奖品失效时间" @change="dataSearch"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item label="奖品" v-if="form.hasGift == 1">
        <gifts :giftList="form.gifts"></gifts>
      </el-form-item>
      <el-form-item label="范围" prop="scope">
        <el-radio-group v-model="form.scope">
          <el-radio :label="0">指定用户</el-radio>
          <el-radio :label="1">全部用户</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 选择用户弹窗 -->
      <el-form-item label="选择用户" v-if="form.scope == 0">
        <el-button type="primary" @click="getCommodity">选择用户</el-button>
        <el-button type="danger" @click="batchDelete">批量删除</el-button>
        <el-table size="small" :key="tableKey" :data="multipleSelection" ref="tableRef" stripe border
          highlight-current-row style="max-width: 1450px;margin-top: 20px">
          <el-table-column align="center" label width="180" type="selection"></el-table-column>
          <el-table-column align="center" label="id" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="靓号id">
            <template slot-scope="scope">
              <span>{{ scope.row.specificCode }}</span>
            </template>
          </el-table-column>
          <el-table-column width="270" align="center" label="注册时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="昵称">
            <template slot-scope="scope">
              <span>{{ scope.row.nickname }}</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="头像">
            <template slot-scope="scope">
              <img :src="scope.row.avatar" style="width:80px;height:80px;object-fit: cover" />
            </template>
          </el-table-column>
          <el-table-column width="180" align="center" label="号码">
            <template slot-scope="scope">
              <span>{{ scope.row.mobile }}</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="总经验值">
            <template slot-scope="scope">
              <span>{{ scope.row.pointAmount || '无' }}</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="等级">
            <template slot-scope="scope">
              <span>{{ scope.row.levelName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row,$index }">
              <el-button type="danger" size="mini" @click="removeGoodsList(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="跳转地址" required>
        <jumpType2 :Jumpurls="form.Jumpurl"></jumpType2>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="cancel('form')">清 空</el-button> -->
      <el-button type="primary" @click="getAdopt('form')"
        v-permission:function="['sendMessageManasger:btn_out']">发送</el-button>
    </div>
    <users :visible.sync="dlGoodsShow" :select-list.sync="dialogGoodsList" @on-select="onSelect"></users>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getSend } from '@/api/demo/news/index'
import gifes from '@/components/prize/gifts/index.vue'
import { certList } from '@/api/demo/close/index'
import users from '../../../components/users/index.vue'
import jumpType2 from '@/components/jumpType/jumpType.vue'
export default {
  name: 'sendMessageManasger',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    gifes,
    users,
    jumpType2
  },
  data () {
    return {
      dialogFormVisible: false,
      tableKey: 0,
      userList: [],
      sendMessageManasger_btn_out: false,
      multipleSelection: [], // 用户数据
      dlGoodsShow: false,
      dialogGoodsList: [], // 弹窗用户列表
      form: {
        title: '', // 消息标题
        skipUrl: '', // 跳转地址
        Jumpurl: {
          url: null,
          id: null,
          classId: null,
          paramType: '0',
          value: ''
        },
        pop: 0, // 是否弹窗 1 是 0 否
        hasGift: 1, // 是否有奖品 1 是 0 否
        certIds: [], // 限制参与证书
        scope: 0,
        accountIds: [], // 用户id
        giftFailureTime: null, // 奖品有效时间
        content: '', // 消息内容
        gifts: [
          {
            name: '',
            count: 0,
            icon: '',
            type: 0, // 类型
            value: null,
            value2: '',
            getCardList: [] // 卡片集合
          }
        ]
      },
      certIdList: [], // 证书集合
      listLoading: false,
      rules: {
        title: [{ required: true, message: '请输入消息标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入消息内容', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let that = this
    that.getSearch()
  },
  mounted () { },
  methods: {
    // 清空
    cancel (form) {
      this.$refs[form].resetFields()
    },
    // 发送
    getAdopt (forms) {
      let that = this
      that.form.accountIds = [...new Set(that.form.accountIds)]
      that.form.skipUrl = that.form.Jumpurl.url
      this.$refs[forms].validate(valid => {
        if (valid) {
          getSend(that.form).then(res => {
            that.$message({
              message: '发送成功',
              type: 'success',
              center: true
            })
            that.$refs[forms].resetFields()
          })
        }
      })
      console.log('form', this.form)
    },
    getSearch () {
      let that = this
      certList(that.listQuery).then(res => {
        that.listLoading = true
        that.certIdList = res.records
        that.listLoading = false
      })
    },
    getGrant (id) {
      this.userID = id
      console.log('ids', id, this.userID)
      this.dialogFormVisible = true
    },
    // 选择商品
    getCommodity () {
      this.dlGoodsShow = true
      this.dialogGoodsList = this.multipleSelection // 勾选回选
    },
    // 商品弹窗确认选择
    async onSelect (data) {
      let that = this
      if (this.multipleSelection == '') {
        data.forEach(item => {
          this.multipleSelection.push({
            specificCode: item.specificCode,
            id: item.id,
            createTime: item.createTime,
            nickname: item.nickname,
            avatar: item.avatar,
            mobile: item.mobile,
            pointAmount: item.pointAmount,
            levelName: item.levelName
          })
        })
      } else {
        data.map(item => {
          this.multipleSelection.push({
            specificCode: item.specificCode,
            id: item.id,
            createTime: item.createTime,
            nickname: item.nickname,
            avatar: item.avatar,
            mobile: item.mobile,
            pointAmount: item.pointAmount,
            levelName: item.levelName
          })
        })
      }
      this.$nextTick(function () {
        var result = []
        var obj = {}
        // 数组去重
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (!obj[this.multipleSelection[i].id]) {
            result.push(this.multipleSelection[i])
            obj[this.multipleSelection[i].id] = true
          }
        }
        this.multipleSelection = result
      })
      //   console.log(this.multipleSelection, "this.multipleSelection");
      for (let index = 0; index < that.multipleSelection.length; index++) {
        that.form.accountIds.push(that.multipleSelection[index].id)
      }
    },
    // 删除商品
    async removeGoodsList (row, index) {
      let that = this
      this.multipleSelection.splice(index, 1)
      that.form.accountIds = []
      for (let index = 0; index < that.multipleSelection.length; index++) {
        that.form.accountIds.push(that.multipleSelection[index].id)
      }
      //   console.log("index0", index, this.multipleSelection);
    },
    // 批量删除
    async batchDelete () {
      let that = this
      if (!that.$refs.tableRef.selection.length) {
        that.$message.error('请勾选要删除的商品')
        return
      }
      var seid = that.$refs.tableRef.selection
      let itmu = that.multipleSelection
      for (let i = 0; i < seid.length; i++) {
        for (let y = 0; y < itmu.length; y++) {
          if (JSON.stringify(itmu[y]) == JSON.stringify(seid[i])) {
            // 判断是否相等，相等就删除
            console.log(itmu[y])
            that.multipleSelection.splice(y, 1)
            // console.log(that.multipleSelection, "that.form.multipleSelection");
          }
        }
      }
      that.form.accountIds = []
      that.multipleSelection.forEach(item => {
        that.form.accountIds.push(item.id)
      })
      that.form.accountIds = [...new Set(that.form.accountIds)]
      //   console.log("that.form", that.form.accountIds, that.multipleSelection);
    },
    // 有效时间
    dataSearch (e) {
      this.form.giftFailureTime = e
    }
  }
}
</script>
<style scope>
.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.margins {
  margin-bottom: 30px !important;
}
</style>
